var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return !_vm.hide
    ? _c("div", { staticClass: "form-network form-network-threads" }, [
        _vm.draftInstance.form.urlsTextContentHistory.length
          ? _c("details", { attrs: { open: "" } }, [
              _c("summary", [
                _vm._v(
                  "\n            " +
                    _vm._s(_vm.$t("dash.post-creator.form.link-preview")) +
                    "\n            "
                ),
                _c("i", { staticClass: "fa-solid fa-caret-down" }),
              ]),
              _c("div", { staticClass: "content-detail form-link" }, [
                _vm.draftInstance.form.urlsTextContent.length
                  ? _c("p", { staticClass: "previewLinkDisabled" }, [
                      _c("i", {
                        staticClass: "fa-regular fa-circle-exclamation",
                      }),
                      _vm._v(
                        "\n                " +
                          _vm._s(
                            _vm.$t(
                              "dash.post-creator.form.threads.link-in-content"
                            )
                          ) +
                          "\n            "
                      ),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass: "list-thubmmail",
                    class: {
                      disabled: _vm.draftInstance.form.urlsTextContent.length,
                    },
                  },
                  _vm._l(
                    _vm.draftInstance.form.urlsTextContentHistory,
                    function (url) {
                      return _c(
                        "div",
                        {
                          key: url.value,
                          staticClass: "thubmmail",
                          on: { click: () => _vm.selectUrl(url.value) },
                        },
                        [
                          _c("Checkbox", {
                            attrs: {
                              id: url.value,
                              prefixId: "thubmmail-",
                              isChecked:
                                _vm.draftInstance.form.networks.threads.snippet
                                  .link == url.value &&
                                !_vm.draftInstance.form.urlsTextContent.length,
                              isDisable:
                                _vm.draftInstance.form.networks.threads.snippet
                                  .link == url.value ||
                                _vm.draftInstance.form.urlsTextContent.length,
                              add: _vm.selectUrl,
                              remove: () => {},
                            },
                          }),
                          _c("SnippetNetwork", {
                            attrs: {
                              link: url.value,
                              imageUrlDefault:
                                !_vm.inputModel.switchCustomSnippet ||
                                _vm.inputModel.titleSnippet ||
                                _vm.inputModel.descriptionSnippet
                                  ? undefined
                                  : _vm.inputModel.urlImageSnippet,
                              titleDefault: _vm.inputModel.switchCustomSnippet
                                ? _vm.inputModel.titleSnippet
                                : undefined,
                              descriptionDefault: _vm.inputModel
                                .switchCustomSnippet
                                ? _vm.inputModel.descriptionSnippet
                                : undefined,
                            },
                          }),
                        ],
                        1
                      )
                    }
                  ),
                  0
                ),
              ]),
            ])
          : _vm._e(),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }